// ============= Imports =============
import React from 'react';
import { FiChevronRight, FiTrash2 } from 'react-icons/fi';
import { CREATE_PROMPT_MESSAGES } from '@/constants/visualPrompts/createPromptMessages';
import { FeaturedStarButton } from '../../FeaturedStarButton';
import { PROMPT_TYPE_LABELS } from '@/constants/visualPrompts/promptCategories';
import { VISUAL_PROMPT_MESSAGES } from '@/constants/visualPrompts/messages';
import {
  CardActions,
  CardButton,
  CardChevron,
  DeleteButton,
  CardDescription,
  CardMain,
  CardMeta,
  CardTitle,
  CardTitleRow,
  MetaBadge,
  StepBadge,
} from './styles';
import type { CompactVisualPromptCardProps } from './types';

// ============= Component =============
export const CompactVisualPromptCard: React.FC<CompactVisualPromptCardProps> = ({
  definition,
  onSelect,
  onDelete,
  onToggleFeatured,
  disabled = false,
}) => {
  const isFeatured = definition.isFeatured === true;
  const stepCount = definition.steps.filter((s) => s.type !== 'review').length;
  const typeLabel =
    PROMPT_TYPE_LABELS[definition.promptType] ?? definition.promptType;

  return (
    <CardButton
      type="button"
      disabled={disabled}
      $disabled={disabled}
      onClick={() => !disabled && onSelect(definition)}
    >
      <CardMain>
        <CardTitleRow>
          {onToggleFeatured && (
            <FeaturedStarButton
              isFeatured={isFeatured}
              disabled={disabled}
              onToggle={() => onToggleFeatured(definition)}
            />
          )}
          <CardTitle>{definition.title}</CardTitle>
        </CardTitleRow>
        <CardDescription>{definition.description}</CardDescription>
        <CardMeta>
          {definition.isCustom && <MetaBadge>Yours</MetaBadge>}
          <MetaBadge>{typeLabel}</MetaBadge>
          <StepBadge>
            {stepCount} {VISUAL_PROMPT_MESSAGES.stepsLabel}
          </StepBadge>
        </CardMeta>
      </CardMain>
      <CardActions>
        {definition.isCustom && onDelete && (
          <DeleteButton
            type="button"
            disabled={disabled}
            aria-label={CREATE_PROMPT_MESSAGES.deleteAriaLabel}
            onClick={(e) => {
              e.stopPropagation();
              onDelete(definition);
            }}
          >
            <FiTrash2 />
          </DeleteButton>
        )}
        <CardChevron aria-hidden>
          <FiChevronRight />
        </CardChevron>
      </CardActions>
    </CardButton>
  );
};
